import { render, staticRenderFns } from "./uaweeklyreport.vue?vue&type=template&id=2cf2e6e2&scoped=true"
import script from "./uaweeklyreport.vue?vue&type=script&lang=js"
export * from "./uaweeklyreport.vue?vue&type=script&lang=js"
import style0 from "./uaweeklyreport.vue?vue&type=style&index=0&id=2cf2e6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf2e6e2",
  null
  
)

export default component.exports